import {InboxModel} from '../../../../../../libs/shared/core/src/models/api/inboxModel';
import {TeammateModel} from '../../../../../../libs/shared/core/src/models/api/teammateModel';
import {CollapsedStateKey} from '../../../../../helpers/expansionTogglingHelpers';
import {VisualCustomView} from '../../../../../helpers/models/customViewHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {
  WorkspaceChangeId,
  WorkspaceTeamChange,
} from '../../../../../store/data/workspace/visualWorkspace/visualWorkspaceUpdateHelpers';

/*
 * Constants.
 */

export const workspacesEditorDropdownWidth = 260;
export const workspacesEditorDropdownHeight = 342;

/*
 * Enums.
 */

/**
 * Represents the dialogs and dropdowns that are controlled by the workspaces editor context and provider.
 *
 * Note the the {@link NestingTeamTagDialogConfirmationContainer} can also appear when editing P1, but that
 * is controlled externally by {@link WorkspaceCustomViewItemContainer}.
 */
export enum WorkspacesEditorDialogsEnum {
  DISCARD = 'DISCARD',
  CONFLICT = 'CONFLICT',
  ERROR = 'ERROR',
}

/*
 * Types.
 */

export interface WorkspacesEditorTeamsPatch {
  teamId: WorkspaceChangeId;
  inboxes: ReadonlyArray<WorkspaceChangeId>;
  tags: ReadonlyArray<WorkspaceChangeId>;
}

// Handler to toggle team custom views in P1.
export type ToggleTeamCustomViewHandler = (teamChange: WorkspaceTeamChange, ifUsedHelpTip: boolean) => void;

// Handler to toggle team custom views in search modal.
export type ToggleDropdownTeamCustomViewHandler = (customView: TagModel, teamId: number) => void;

// Handler to toggle team inboxes in P1.
export type ToggleTeamInboxHandler = (teamChange: WorkspaceTeamChange, ifUsedHelpTip: boolean) => void;
// Handler to toggle team inboxes in search modal.
export type ToggleDropdownTeamInboxHandler = (inbox: InboxModel, teamId: number) => void;

// Handler to toggle teammates in search modal.
export type ToggleDropdownTeammateHandler = (teammate: TeammateModel) => void;

export interface VisualCustomViewsForNamespace {
  namespace: string;
  visualCustomViews: ReadonlyArray<VisualCustomView>;
}

export interface WorkspacesEditorVisualCustomViewsMap {
  visible: ReadonlyArray<VisualCustomView>;
  privateHidden: ReadonlyArray<VisualCustomView>;
  teamsHidden: ReadonlyArray<VisualCustomViewsForNamespace>;
}

export interface ToggleExpandTagArgs {
  tagId: WorkspaceChangeId;
  defaultExpandedState: boolean;
}

export type ToggleExpandTagHandler = (args: ToggleExpandTagArgs) => void;

export interface ToggleExpandItemArgs {
  key: CollapsedStateKey;
  defaultExpandedState: boolean;
}

export type ToggleExpandItemHandler = (args: ToggleExpandItemArgs) => void;
